import { useEffect, useState } from "react";

export const RelatedSitesTester: React.FC = () => {
    const [query, setQuery] = useState<string>("");
    const [relatedSites, setRelatedSites] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>("");
    
    useEffect(() => {
        if (!query) {
            setRelatedSites(null);
            return;
        }

        const asyncFunc = async () => {
            setIsLoading(true);
            setError("");
            try {
                const response = await fetch(`/api/RelatedSitesSearch?query=${encodeURIComponent(query)}`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' }
                });
                
                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error(errorText || `HTTP Error ${response.status}`);
                }
                
                const answer = await response.json();
                console.log("answer", answer);
                return answer;
            } catch (err: any) {
                console.error(err);
                setError(err.message || "Ein Fehler ist aufgetreten");
                return null;
            } finally {
                setIsLoading(false);
            }
        };

        asyncFunc().then(result => {
            setRelatedSites(result);
        });
    }, [query]);

    return (
        <div>
            <h2>Related Sites Tester</h2>
            <p>
                Suchtext:<br />
                <input 
                    type="text" 
                    id="searchQuery" 
                    style={{ width: '80%' }} 
                    placeholder="Geben Sie einen Suchbegriff ein..."
                    onBlur={(e) => setQuery(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            setQuery(e.currentTarget.value);
                        }
                    }}
                />
            </p>
            
            {isLoading && <p>Laden...</p>}
            {error && <p style={{ color: 'red' }}>Fehler: {error}</p>}
            
            {query && relatedSites && !isLoading && (
                <>
                    <h3>Suchergebnisse für: "{query}"</h3>
                    <p>Anzahl Resultate: {relatedSites?.length || 0}</p>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead style={{ textAlign: 'left', backgroundColor: '#f0f0f0' }}>
                            <tr>
                                <th style={{ padding: '8px', border: '1px solid #ddd' }}>#</th>
                                <th style={{ padding: '8px', border: '1px solid #ddd' }}>Titel</th>
                                <th style={{ padding: '8px', border: '1px solid #ddd' }}>Link</th>
                                <th style={{ padding: '8px', border: '1px solid #ddd' }}>Datenquelle</th>
                                <th style={{ padding: '8px', border: '1px solid #ddd' }}>Beschreibung</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(relatedSites || []).map((site: any, index: number) => {
                                return (
                                    <tr 
                                        key={index} 
                                        style={{ 
                                            backgroundColor: index % 2 === 0 ? 'white' : '#f9f9f9' 
                                        }}
                                    >
                                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                            {index + 1}
                                        </td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                            {site.title}
                                        </td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                            <a 
                                                href={site.link} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                style={{ color: '#0066cc', textDecoration: 'none' }}
                                            >
                                                {site.link}
                                            </a>
                                        </td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                            {site.datasourceName || '-'}
                                        </td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd', fontSize: '0.8em' }}>
                                            {site.snippet || '-'}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </>
            )}
        </div>
    );
};
